/** Returns true if `value` is a [[DayOfWeek]] type. */
export function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}
//# sourceMappingURL=isDayOfWeekType.js.map